// extracted by mini-css-extract-plugin
module.exports = {"editModal":"style_editModal__2Vgas"};